import { ProjectSettingWithRelations } from '@rappider/rappider-sdk';

export const DEFAULT_PROJECT_SETTING_DATA = <ProjectSettingWithRelations>{
  key: null,
  value: null,
  isSystemGenerated: false
};
